import { render, staticRenderFns } from "./inclusionsModal.vue?vue&type=template&id=b4122bec&scoped=true"
import script from "./inclusionsModal.vue?vue&type=script&lang=js"
export * from "./inclusionsModal.vue?vue&type=script&lang=js"
import style0 from "./inclusionsModal.vue?vue&type=style&index=0&id=b4122bec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4122bec",
  null
  
)

export default component.exports